import { CargoMode } from "app/types/enums";

export const getContainerData = (row, sp) => {
    if (row.cargoMode === CargoMode.LCL) {
        if (sp.container) {
            return `${sp.container} - ${row.cargoMode}`;
        }
        return `${row.cargoMode}`;
    }

    var size = sp.packageTypeDescription?.toLowerCase().match(/(\d+)'/);

    if (size && size.length > 1) {
        if (sp.container) {
            return `${sp.container} - ${size[0]}`;
        }
        return `${size[0]}`;
    }
    return sp.container;
};